import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toggleCart from "../redux/toggleCart";

function AddToCartButton({ product, quantityToAdd, hasFormBeenSubmitted }) {
  const productInCart = useSelector((state) =>
    state.shoppingCart.content.find((cartProduct) => cartProduct.id === product.id),
  );
  const amountInCart = productInCart ? productInCart.quantity : 0;
  const customer = useSelector((state) => state.customer);
  const [warning, setWarning] = useState(false);
  const dispatch = useDispatch();
  const quantityLeft = product.inStock - amountInCart;

  const handleClick = async () => {
    if (quantityLeft <= 0 || quantityToAdd === 0) return;
    if (quantityLeft < quantityToAdd) {
      setWarning(true);
    } else {
      setWarning(false);
      dispatch(toggleCart(product, quantityToAdd));
      dispatch({ type: "TOGGLE_CART_VISIBILITY" });
    }
  };

  useEffect(() => {
    if (hasFormBeenSubmitted) {
      handleClick();
    }
  }, [hasFormBeenSubmitted]);

  return (
    <>
      <div className="add-to-cart-button" onClick={handleClick}>
        {quantityLeft > 0 ? (
          <span>
            <i className="fas fa-shopping-cart"></i> Add to Cart
          </span>
        ) : (
          <span className="text-danger">OUT OF STOCK</span>
        )}
      </div>
      {warning && (
        <p className="text-danger">
          We are sorry. There is not enough stock of this product to perform this action.
        </p>
      )}
    </>
  );
}

export default AddToCartButton;
